(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-demo"] && !Shopify.designMode) return;
  try {
    
  class AppDemoTabs {
    constructor(root) {
      this.root = root;
      this.tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      if (this.tabs.length < 2) return;

      this.panels = this.tabs
        .map((tab) => root.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls'))))
        .filter(Boolean);

      if (this.panels.length !== this.tabs.length) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.select(0, false);
    }

    select(index, focus = true) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        this.panels[i].hidden = !selected;
      });

      if (focus) this.tabs[index].focus();
    }

    onKeydown(event, index) {
      const keys = {
        ArrowRight: index + 1,
        ArrowLeft: index - 1,
        Home: 0,
        End: this.tabs.length - 1,
      };

      if (!(event.key in keys)) return;

      event.preventDefault();
      const next = (keys[event.key] + this.tabs.length) % this.tabs.length;
      this.select(next);
    }
  }

  function initAppDemos() {
    document.querySelectorAll('.app-demo').forEach((root) => new AppDemoTabs(root));
  }

  document.addEventListener('DOMContentLoaded', initAppDemos);
  document.addEventListener('shopify:section:load', initAppDemos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-cta"]) return;
  try {
    
  function initMobileCta() {
    const bar = document.querySelector('.mobile-cta');
    if (!bar) return;

    const ratio = parseFloat(bar.dataset.revealAfter || '80') / 100;
    let ticking = false;

    function update() {
      ticking = false;
      const passed = window.scrollY > window.innerHeight * ratio;
      const nearBottom =
        window.innerHeight + window.scrollY >= document.body.scrollHeight - 120;
      bar.classList.toggle('is-visible', passed && !nearBottom);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  document.addEventListener('DOMContentLoaded', initMobileCta);
  document.addEventListener('shopify:section:load', initMobileCta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-offer"] && !Shopify.designMode) return;
  try {
    
  function initOfferThumbs() {
    document.querySelectorAll('.offer__card').forEach((card) => {
      const main = card.querySelector('.offer__card-image');
      const thumbs = card.querySelectorAll('.offer__thumb');
      if (!main || thumbs.length === 0) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = thumb.dataset.full;
          thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initOfferThumbs);
  document.addEventListener('shopify:section:load', initOfferThumbs);

  } catch(e) { console.error(e); }
})();
})();
